// extracted by mini-css-extract-plugin
module.exports = {"container":"Controls_container___ni0C","title":"Controls_title__loiTI","controls":"Controls_controls__BY2-d","rightControls":"Controls_rightControls__1pREk"};